import React, { Component } from 'react';
// import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import styled from "styled-components";

import Header from "./Header";

class Layout extends Component {
  render() {
    return (
        <LayoutWrapper>
            <Header />
            <Container className="container-fluid">
                {this.props.children}
            </Container>
        </LayoutWrapper>
    );
  }
}

export default Layout;

const LayoutWrapper = styled.div`
  background: #f2f4f6;
  min-height: 100vh;
  padding-bottom: 50px;
  padding-top: 68px;
`;

const Container = styled.div`
  padding: 30px 0;
`;
